// extracted by mini-css-extract-plugin
module.exports = {"custom_404":"custom404_custom_404__tie1s","heading":"custom404_heading__AHVJP","message":"custom404_message__AX7aa"};